import React from "react";
import { I2cSpinner } from "@webcomponents/i2cwebcomponents/dist/react";

const Spinner = (props) => {
  return (
    <div className={"loadingSpinner"}>
      <I2cSpinner size="large" label={props.label} />
    </div>
  );
};

export default Spinner;
